
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { TextField } from 'mui-rff';
import { Form } from 'react-final-form';

interface MasterWorkoutExerciseBatchEditProps {
	onCancel: () => void
	onConfirm: (value: any) => void
	week: number
}
const MasterWorkoutExerciseBatchEdit: React.FC<MasterWorkoutExerciseBatchEditProps> = ({ onConfirm, onCancel, week }) => {
	return (
		<Dialog open={week > 0} maxWidth="xs" fullWidth onBackdropClick={onCancel}>
			<DialogTitle>{`Batch edit for week ${week}`}</DialogTitle>
			<Box position="absolute" top={0} right={0}>
				<IconButton onClick={onCancel}>
					<CloseIcon />
				</IconButton>
			</Box>
			<Form
				onSubmit={onConfirm}
				initialValues={{
                    rir: null
                }}
				render={({ handleSubmit, form }) => {
					return (
						<form onSubmit={handleSubmit} noValidate>
							<DialogContent>
								<Box display="flex" justifyContent="center">
									<Typography variant="h4">The value you enter in this field will apply to every exercise in Week #{week}.</Typography>
								</Box>

								<Box display="flex" justifyContent="center" my={2}>
									<TextField type="text" label="Rir" name="rir" />
								</Box>
							</DialogContent>
							<DialogActions>
								<Button color="primary" variant="contained" onClick={onCancel}>
									Cancel
								</Button>
								<Button color="secondary" variant="outlined" type="submit">
									Confirm
								</Button>
							</DialogActions>
						</form>
					)
				}}
			/>
		</Dialog>
	)
}
  
  export default MasterWorkoutExerciseBatchEdit;